export default __webpack_public_path__ + "static/media/coffeeAndPhone.6dcaef89.jpg";